import { Injectable } from "@angular/core";
import { end } from "@popperjs/core/lib/enums";

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    constructor() { }

    private themes = {
        default: {
            '--app-bg': '#ffffff',
            '--page-bg': '#ffffff',
            '--primary-color': '#16566a',
            '--cancel-color': '#ffffff',
            '--primary-dark': '#0f4c60',
            '--accent-color': '#13a6b7',
            '--header-bg-start': '#eef6ff',
            '--header-bg-mid': '#d6e6ff',
            '--header-bg-end': '#c8eef4',
            '--surface-color': '#ffffff',
            '--surface-tint': '#b3e5fc',
            '--surface-muted': '#e2eaf3',
            '--text-color': '#16566a',
            '--nav-text-color': '#16566a',
            '--menu-bg': '#d6e6ff',
            '--menu-text': '#16566a',
            '--table-header-bg': '#d6e6ff',
            '--table-header-text': 'black',
            '--btn-bg': 'blue',
            '--btn-text': '#ffffff',
            '--button-strong-bg': '#007bff',
            '--button-strong-text': '#ffffff',
            '--button-border': '#0056b3',
            '--cancel-button': '#fa3a3a',
            '--button-hover-bg': '#0056b3',
            '--cancel-button-bg': '#ffffff',
            '--button-hover-text': '#ffffff',
            '--cancel-button-hover-text': '#0F172A',
            '--button-muted-bg': '#e2eaf3',
            '--button-muted-text': '#16566a',
            '--button-soft-bg': 'rgba(22, 86, 106, 0.05)',
            '--card-border': '#ddd',
            '--card-bg': '#ffffff',
            '--card-header-bg': '#d6e6ff',
            '--card-header-text': '#16566a',
            '--sidebar-text': '#16566a',
            '--sidebar-active': '#13a6b7',
            '--border-color': 'rgba(22, 86, 106, 0.18)',
            '--shadow-color': 'rgba(22, 86, 106, 0.16)',
            '--shadow-color-soft': 'rgba(22, 86, 106, 0.12)',
            '--surface-overlay': 'rgba(255, 255, 255, 0.62)',
            '--surface-overlay-hover': 'rgba(255, 255, 255, 0.86)',
            '--day-type-holiday-bg': '#FFEBEE',
            '--day-type-leave-bg': '#FFF1D6',
            '--day-type-first-half-bg': '#FFF1D6',
            '--day-type-second-half-bg': '#FFF1D6',
            '--day-type-optional-holiday-bg': '#DDF5E5',
            '--day-type-official-holiday-bg': '#FFE1E1',
            '--day-type-maternity-leave-bg': 'rgb(46, 173, 232)',
            '--day-type-default-bg': '#d6e6ff',
            '--day-type-lwp-bg': '#fef3c7',
            '--day-type-lwp-border': '#f59e0b',
            '--day-type-lwp-text': '#b45309',
            '--day-type-lwp-icon-bg': '#fffbeb'
        },
        alternate: {
            '--app-bg': '#ffffff',
            '--page-bg': '#ffffff',
            '--primary-color': '#1b5e20',
            '--primary-dark': '#153d12',
            '--accent-color': '#7cb342',
            '--header-bg-start': '#e8f5e9',
            '--header-bg-mid': '#c8e6c9',
            '--header-bg-end': '#a5d6a7',
            '--surface-color': '#ffffff',
            '--surface-tint': '#dcedc8',
            '--surface-muted': '#f1f8e9',
            '--text-color': '#1b5e20',
            '--nav-text-color': '#1b5e20',
            '--menu-bg': '#dcedc8',
            '--menu-text': '#1b5e20',
            '--table-header-bg': '#c8e6c9',
            '--table-header-text': 'black',
            '--btn-bg': '#7cb342',
            '--btn-text': '#ffffff',
            '--button-strong-bg': '#22C55E',
            '--button-strong-text': '#ffffff',
            '--button-border': '#7cb342',
            '--button-hover-bg': '#16A34A',
            '--button-hover-text': '#ffffff',
            '--button-muted-bg': '#f1f8e9',
            '--button-muted-text': '#1b5e20',
            '--button-soft-bg': 'rgba(76, 175, 80, 0.05)',
            '--card-border': '#c5e1a5',
            '--card-bg': '#ffffff',
            '--card-header-bg': '#dcedc8',
            '--card-header-text': '#1b5e20',
            '--sidebar-text': '#1b5e20',
            '--sidebar-active': '#9ccc65',
            '--border-color': 'rgba(76, 175, 80, 0.18)',
            '--shadow-color': 'rgba(76, 175, 80, 0.16)',
            '--shadow-color-soft': 'rgba(76, 175, 80, 0.12)',
            '--surface-overlay': 'rgba(255, 255, 255, 0.62)',
            '--surface-overlay-hover': 'rgba(255, 255, 255, 0.86)',
            '--day-type-holiday-bg': '#fce4ec',
            '--day-type-leave-bg': '#fff9c4',
            '--day-type-first-half-bg': '#fff9c4',
            '--day-type-second-half-bg': '#fff9c4',
            '--day-type-optional-holiday-bg': '#e8f5e9',
            '--day-type-official-holiday-bg': '#fce4ec',
            '--day-type-maternity-leave-bg': '#e3f2fd',
            '--day-type-default-bg': '#f1f8e9',
            '--day-type-lwp-bg': '#fef3c7',
            '--day-type-lwp-border': '#f59e0b',
            '--day-type-lwp-text': '#b45309',
            '--day-type-lwp-icon-bg': '#fffbeb'
        },
        sunset: {
            '--app-bg': '#FFFDFC',
            '--page-bg': '#FFF8F2',
            '--primary-color': '#C2410C',
            '--primary-dark': '#9A3412',
            '--accent-color': '#F97316',
            '--header-bg-start': '#FFF4E6',
            '--header-bg-mid': '#FFE4CC',
            '--header-bg-end': '#FFD6B3',
            '--surface-color': '#FFFFFF',
            '--surface-tint': '#FFF1E6',
            '--surface-muted': '#FFF7F0',
            '--text-color': '#7C2D12',
            '--nav-text-color': '#7C2D12',
            '--menu-bg': '#FFE8D6',
            '--menu-text': '#7C2D12',
            '--table-header-bg': '#FFE4CC',
            '--table-header-text': '#7C2D12',
            '--btn-bg': '#F97316',
            '--btn-text': '#FFFFFF',
            '--button-strong-bg': '#EA580C',
            '--button-strong-text': '#FFFFFF',
            '--button-border': '#C2410C',
            '--button-hover-bg': '#9A3412',
            '--button-hover-text': '#FFFFFF',
            '--button-muted-bg': '#FFF1E6',
            '--button-muted-text': '#9A3412',
            '--button-soft-bg': 'rgba(249, 115, 22, 0.08)',
            '--card-border': '#FFD8BF',
            '--card-bg': '#FFFFFF',
            '--card-header-bg': '#FFE4CC',
            '--card-header-text': '#7C2D12',
            '--sidebar-text': '#7C2D12',
            '--sidebar-active': '#FB923C',
            '--border-color': 'rgba(249, 115, 22, 0.18)',
            '--shadow-color': 'rgba(249, 115, 22, 0.16)',
            '--shadow-color-soft': 'rgba(249, 115, 22, 0.10)',
            '--surface-overlay': 'rgba(255,255,255,0.65)',
            '--surface-overlay-hover': 'rgba(255,255,255,0.88)',
            '--day-type-holiday-bg': '#FFE5E5',
            '--day-type-leave-bg': '#FFF3D6',
            '--day-type-first-half-bg': '#FFF3D6',
            '--day-type-second-half-bg': '#FFF3D6',
            '--day-type-optional-holiday-bg': '#E4F8EA',
            '--day-type-official-holiday-bg': '#FFE1E1',
            '--day-type-maternity-leave-bg': '#D9F1FF',
            '--day-type-default-bg': '#FFF1E6',
            '--day-type-lwp-bg': '#fef3c7',
            '--day-type-lwp-border': '#f59e0b',
            '--day-type-lwp-text': '#b45309',
            '--day-type-lwp-icon-bg': '#fffbeb'
        },
        midnight: {
            '--app-bg': '#F4F7FB',
            '--page-bg': '#EEF2F7',
            '--primary-color': '#1E3A5F',
            '--primary-dark': '#14273F',
            '--accent-color': '#4F8CFF',
            '--header-bg-start': '#E8EEF8',
            '--header-bg-mid': '#D8E3F2',
            '--header-bg-end': '#C8D7EB',
            '--surface-color': '#FFFFFF',
            '--surface-tint': '#F5F9FF',
            '--surface-muted': '#EAF1F8',
            '--text-color': '#1F2937',
            '--nav-text-color': '#1E3A5F',
            '--menu-bg': '#DCE7F5',
            '--menu-text': '#1E3A5F',
            '--table-header-bg': '#D8E3F2',
            '--table-header-text': '#1E293B',
            '--btn-bg': '#2563EB',
            '--btn-text': '#FFFFFF',
            '--button-strong-bg': '#1D4ED8',
            '--button-strong-text': '#FFFFFF',
            '--button-border': '#1E40AF',
            '--button-hover-bg': '#1E40AF',
            '--button-hover-text': '#FFFFFF',
            '--button-muted-bg': '#F1F5F9',
            '--button-muted-text': '#334155',
            '--button-soft-bg': 'rgba(37, 99, 235, 0.08)',
            '--card-border': '#D6E0EC',
            '--card-bg': '#FFFFFF',
            '--card-header-bg': '#E8EEF8',
            '--card-header-text': '#1E3A5F',
            '--sidebar-text': '#1E3A5F',
            '--sidebar-active': '#60A5FA',
            '--border-color': 'rgba(30, 58, 95, 0.12)',
            '--shadow-color': 'rgba(15, 23, 42, 0.10)',
            '--shadow-color-soft': 'rgba(15, 23, 42, 0.05)',
            '--surface-overlay': 'rgba(255,255,255,0.68)',
            '--surface-overlay-hover': 'rgba(255,255,255,0.90)',
            '--day-type-holiday-bg': '#FDECEC',
            '--day-type-leave-bg': '#FFF4D6',
            '--day-type-first-half-bg': '#FFF4D6',
            '--day-type-second-half-bg': '#FFF4D6',
            '--day-type-optional-holiday-bg': '#E4F7EA',
            '--day-type-official-holiday-bg': '#FFE2E2',
            '--day-type-maternity-leave-bg': '#D9ECFF',
            '--day-type-default-bg': '#E8EEF8',
            '--day-type-lwp-bg': '#fef3c7',
            '--day-type-lwp-border': '#f59e0b',
            '--day-type-lwp-text': '#b45309',
            '--day-type-lwp-icon-bg': '#fffbeb'
        },
        corporate: {
            '--app-bg': '#F5F7FB',
            '--page-bg': '#EEF2F7',
            '--primary-color': '#0F172A',
            '--primary-dark': '#020617',
            '--accent-color': '#3B82F6',
            '--header-bg-start': '#F8FAFC',
            '--header-bg-mid': '#E2E8F0',
            '--header-bg-end': '#CBD5E1',
            '--surface-color': '#FFFFFF',
            '--surface-tint': '#F8FAFC',
            '--surface-muted': '#F1F5F9',
            '--text-color': '#1E293B',
            '--nav-text-color': '#0F172A',
            '--menu-bg': '#E2E8F0',
            '--menu-text': '#0F172A',
            '--table-header-bg': '#E2E8F0',
            '--table-header-text': '#0F172A',
            '--btn-bg': '#2563EB',
            '--btn-text': '#FFFFFF',
            '--button-strong-bg': '#2563EB',
            '--button-strong-text': '#FFFFFF',
            '--button-border': '#1D4ED8',
            '--button-hover-bg': '#1D4ED8',
            '--button-hover-text': '#FFFFFF',
            '--button-muted-bg': '#F1F5F9',
            '--button-muted-text': '#334155',
            '--button-soft-bg': 'rgba(37, 99, 235, 0.06)',
            '--card-border': '#DCE3EC',
            '--card-bg': '#FFFFFF',
            '--card-header-bg': '#E2E8F0',
            '--card-header-text': '#0F172A',
            '--sidebar-text': '#0F172A',
            '--sidebar-active': '#3B82F6',
            '--border-color': 'rgba(15, 23, 42, 0.08)',
            '--shadow-color': 'rgba(15, 23, 42, 0.08)',
            '--shadow-color-soft': 'rgba(15, 23, 42, 0.04)',
            '--surface-overlay': 'rgba(255,255,255,0.72)',
            '--surface-overlay-hover': 'rgba(255,255,255,0.92)',
            '--day-type-holiday-bg': '#FEECEC',
            '--day-type-leave-bg': '#FFF6DB',
            '--day-type-first-half-bg': '#FFF6DB',
            '--day-type-second-half-bg': '#FFF6DB',
            '--day-type-optional-holiday-bg': '#E8F7EC',
            '--day-type-official-holiday-bg': '#FFE4E4',
            '--day-type-maternity-leave-bg': '#E0F2FE',
            '--day-type-default-bg': '#EAF1F8',
            '--day-type-lwp-bg': '#fef3c7',
            '--day-type-lwp-border': '#f59e0b',
            '--day-type-lwp-text': '#b45309',
            '--day-type-lwp-icon-bg': '#fffbeb'
        },
        violet: {
            '--app-bg': '#F5F3FF',
            '--page-bg': '#EEE9FF',

            /* Primary Colors */
            '--primary-color': '#6D28D9',
            '--primary-dark': '#5B21B6',
            '--accent-color': '#8B5CF6',

            /* Header */
            '--header-bg-start': '#F3EEFF',
            '--header-bg-mid': '#E5DBFF',
            '--header-bg-end': '#D8C8FF',

            /* Surfaces */
            '--surface-color': '#FFFFFF',
            '--surface-tint': '#F8F5FF',
            '--surface-muted': '#EEE9FF',

            /* Text */
            '--text-color': '#3B0764',
            '--nav-text-color': '#3B0764',

            /* Menu */
            '--menu-bg': '#8949ff54',
            '--menu-text': '#4C1D95',

            /* Table */
            '--table-header-bg': '#E5DBFF',
            '--table-header-text': '#3B0764',

            /* Buttons */
            '--btn-bg': '#7C3AED',
            '--btn-text': '#FFFFFF',

            '--button-strong-bg': '#6D28D9',
            '--button-strong-text': '#FFFFFF',

            '--button-border': '#5B21B6',

            '--button-hover-bg': '#5B21B6',
            '--button-hover-text': '#FFFFFF',

            '--button-muted-bg': '#F3EEFF',
            '--button-muted-text': '#5B21B6',

            '--button-soft-bg': 'rgba(124, 58, 237, 0.08)',

            /* Cards */
            '--card-border': '#D9CCFF',
            '--card-bg': '#FFFFFF',

            '--card-header-bg': '#E9DDFF',
            '--card-header-text': '#4C1D95',

            /* Sidebar */
            '--sidebar-text': '#4C1D95',
            '--sidebar-active': '#8B5CF6',

            /* Borders & Shadows */
            '--border-color': 'rgba(124, 58, 237, 0.16)',

            '--shadow-color': 'rgba(91, 33, 182, 0.18)',

            '--shadow-color-soft': 'rgba(91, 33, 182, 0.10)',

            /* Overlays */
            '--surface-overlay': 'rgba(255,255,255,0.70)',
            '--surface-overlay-hover': 'rgba(255,255,255,0.92)',

            /* Day Types */

            /* Holiday */
            '--day-type-holiday-bg': '#FFE4E6',

            /* Leave */
            '--day-type-leave-bg': '#FFF4CC',

            '--day-type-first-half-bg': '#FFF4CC',
            '--day-type-second-half-bg': '#FFF4CC',

            /* Optional Holiday */
            '--day-type-optional-holiday-bg': '#DCFCE7',

            /* Official Holiday */
            '--day-type-official-holiday-bg': '#FECACA',

            /* Maternity */
            '--day-type-maternity-leave-bg': '#DBEAFE',

            /* Default Working Day */
            '--day-type-default-bg': '#EEE9FF',

            /* Extra Theme Variables */

            '--label-color': '#4C1D95',
            '--muted-text-color': '#6D28D9',
            '--placeholder-color': '#8B5CF6',

            '--input-bg': '#FFFFFF',
            '--input-text': '#3B0764',
            '--input-border': '#D8C8FF',

            '--table-row-bg': '#FFFFFF',
            '--table-row-text': '#3B0764',

            '--mat-table-text': '#3B0764',
            '--mat-table-header-text': '#4C1D95',

            '--icon-color': '#6D28D9',

            '--form-label-color': '#4C1D95',

            '--dropdown-bg': '#FFFFFF',
            '--dropdown-text': '#3B0764',

            '--modal-bg': '#FFFFFF',
            '--modal-text': '#3B0764'
        }
    };

    setTheme(themeName: string) {
        const normalizedTheme = (themeName || 'default').trim().toLowerCase().replace(/\s+/g, '');
        const theme = this.themes[normalizedTheme] || this.themes.default;
        Object.keys(theme).forEach((key) => {
            document.documentElement.style.setProperty(key, theme[key]);
        });
    }

}